<script>
import { fandomBasicMixin } from 'src/modules/fandom_mixins_module.js';
import { sendFandomAnalyticsEvent } from "src/modules/fandom_analytics_module.js";
import Flickity from "flickity";
import { get } from 'lodash';

export default {
  mixins: [fandomBasicMixin],
  data() {
    return {
      slider: null,
      topicAnswers: [],
      targetAnswer: null,
      industryAnswer: null,
      warningMessage: null,
      confirmed: {
        topic: false,
        target: false,
        industry: false
      }
    }
  },
  mounted() {
    this.topicAnswers = get(this.pageModel, ['user', 'topic'], []);
    this.confirmed['topic'] = !!get(this.pageModel, ['user', 'topic'], false);
    this.targetAnswer = get(this.pageModel, ['user', 'target'], [null])[0];
    this.confirmed['target'] = !!get(this.pageModel, ['user', 'target'], false);
    this.industryAnswer = get(this.pageModel, ['user', 'industry'], [null])[0];
    this.confirmed['industry'] = !!get(this.pageModel, ['user', 'industry'], false);
    Vue.nextTick(() => {
      const slider = new Flickity(this.$refs["profiling-carousel"], {
        draggable: false,
        cellAlign: 'center',
        pageDots: false,
        wrapAround: false,
        adaptiveHeight: true,
        prevNextButtons: false,
        imagesLoaded: true
      });
      Vue.set(this, "slider", slider);
    })
  },
  methods: {
    toggleTopicAnswer(answer) {
      const answerIndex = this.topicAnswers.indexOf(answer);
      if (answerIndex < 0) {
        this.topicAnswers.push(answer);
      } else {
        this.topicAnswers = this.topicAnswers.filter(activeAnswer => answer != activeAnswer);
      }
    },
    toggleTargetAnswer(answer) {
      this.targetAnswer = answer;
    },
    toggleIndustryAnswer(answer) {
      this.industryAnswer = answer;
    },
    confirm() {
      if (this.slider && this.canConfirm) {
        switch(this.slider.selectedIndex) {
          case 0:
            this.submitProfilingAnswer(this.topicAnswers, 'topic', (data) => {
              sendFandomAnalyticsEvent('Registrazione', 'Profilatore', 'default');
            });
            break;
          case 1:
            if (!this.industryAnswer) {
              this.submitProfilingAnswer([this.targetAnswer], 'target', (data) => {
                sendFandomAnalyticsEvent('Profilatore', 'Step 2', this.getContent(this.targetAnswer).title);
              });
            } else {
              this.warningMessage = this.ft('globals.warnings.reinsert_next_answer');
            }
            break;
          case 2:
            this.submitProfilingAnswer([this.industryAnswer], 'industry', () => {
              sendFandomAnalyticsEvent('Profilatore', 'Step 3', this.getContent(this.industryAnswer).title);
              window.location.href = Fandom.isUserRegistered() ? get(this.mainContent, ['profiling_wizard_redirect', 'url'], this.applyContextToUrl('/')) : this.applyContextToUrl('/users/sign_up');
            });
            break;
        }
      }
    },
    submitProfilingAnswer(answer, extraFieldName, successCallback = ()=>{}) {
      Fandom.ajax({
        url: Fandom.applyContextToUrl('/api/v5/profiling'),
        method: 'POST',
        data: {
          answer_content_names: answer,
          extra_field_name: extraFieldName,
          main_content_name: this.content.name,
          interaction_record: this.content[extraFieldName]
        },
        success: (data) => {
          this.confirmed[extraFieldName] = true;
          successCallback(data);
          if (this.slider.selectedIndex < 2) {
            this.slider.next();
          }
          console.log("Data submitted successfully!", data);
          Vue.nextTick(() => {
            this.slider.resize();
          });
        },
        error: (jqXHR,textStatus,errorThrown) => {
          console.error("Some errors occurred...", err);
        }
      })
    }
  },
  computed: {
    industryAnswers() {
      const response = [];
      (this.getContent(this.content.industry.answer_tag).children || []).forEach(child => {
        if (this.getContent(child).parent_names.includes(this.targetAnswer)) {
          response.push(child);
        }
      });
      return response;
    },
    canGoNext() {
      const steps = ["topic", "target", "industry"];
      return this.confirmed[steps[this.slider.selectedIndex]];
    },
    canConfirm() {
      if (this.slider) {
        switch(this.slider.selectedIndex) {
          case 0:
            return this.topicAnswers.length >= 3 && this.topicAnswers.length <= 5;
            break;
          case 1:
            return !!this.targetAnswer;
            break;
          case 2:
            return !!this.industryAnswer;
            break;
          default:
            return false;
            break;
        }
      }
    }
  }
};
</script>

<template>
  <div v-easyadmin="easyadminId" v-if="isContentVisibleToUser()" :class="[contentType]" class="bg-gray-200" stripe-profiling-component>
    <div class="container pt-5">
      <div class="row justify-content-center">
        <div class="col-12 col-lg-10 d-flex flex-column">
          <div class="py-4 d-flex justify-content-between align-items-center">
            <div class="arrow-container">
              <button class="btn btn-outline-dark" v-if="slider" :disabled="slider.selectedIndex == 0" :class="{'d-none': slider.selectedIndex == 0}" @click="slider.previous()">
                <i class="fal fa-2x fa-chevron-left mr-2"></i>
              </button>
            </div>
            <div class="slide-index d-flex justify-content-center small text-gray-500" v-if="slider">
              <span class="text-primary mr-2">{{slider.selectedIndex + 1}}</span> {{ft('globals.of')}} <span class="ml-2">3</span>
            </div>
            <div class="arrow-container">
              <button class="btn btn-outline-dark" v-if="slider" :disabled="!canConfirm" :class="{'disabled': !canConfirm}" @click="canConfirm ? confirm() : ()=>{}">
                <i class="fal fa-2x fa-chevron-right ml-2"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container pb-5">
      <div class="row justify-content-center">
        <div class="col-12 col-lg-10 d-flex flex-column">
          <div class="profiling-carousel py-4 pb-md-5 mx-n2" ref="profiling-carousel">
            <!-- TOPIC SLIDE -->
            <div class="profiling-carousel-item topic px-2" key="slide-topic">
              <h3 class="text-center">{{content.topic.question}}</h3>
              <div class="text-center" v-html="content.topic.details" v-if="content.topic.details"></div>
              <div class="d-flex flex-wrap pt-4 justify-content-center">
                <div
                  v-for="answer in getContent(content.topic.answer_tag).children"
                  :key="`topic-${answer}`"
                  class="cursor-pointer py-2 px-3 topic-item m-2"
                  @click="toggleTopicAnswer(answer)"
                  :class="{'active': topicAnswers.indexOf(answer) >= 0}"
                >
                  <div class="text-center small">{{getContent(answer).title}}</div>
                </div>
              </div>
              <div class="w-100 text-center mt-4">
                <button class="btn btn-primary my-3 my-md-0" :disabled="!canConfirm" :class="{'disabled': !canConfirm}" @click="confirm()">{{ft('globals.continue')}}</button>
              </div>
            </div>
            <!-- END TOPIC SLIDE -->
            <!-- TARGET SLIDE -->
            <div class="profiling-carousel-item target px-2" key="slide-target">
              <h3 class="text-center pb-4">{{content.target.question}}</h3>
              <div class="text-center" v-html="content.target.details" v-if="content.target.details"></div>
              <div class="d-flex flex-column flex-lg-row">
                <div v-for="answer in getContent(content.target.answer_tag).children" :key="`target-${answer}`" class="target-item py-2">
                  <div
                    class="cursor-pointer ar-1by1 tile w-100 h-100 d-flex flex-lg-column justify-content-lg-center align-items-center"
                    :class="{'active': targetAnswer == answer}"
                    @click="toggleTargetAnswer(answer)"
                  >
                    <img :src="getContent(answer).icon.url" v-if="getContent(answer).icon" class="icon mb-3 mr-3 mr-lg-0"/>
                    <div>
                      <div class="font-weight-bold title mb-1">{{getContent(answer).title}}</div>
                      <div class="mb-0 mt-auto" v-if="getContent(answer).description" v-html="getContent(answer).description"></div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="w-100 text-center mt-4 pt-3">
                <button class="btn btn-primary my-3 my-md-0" :disabled="!canConfirm" :class="{'disabled': !canConfirm}" @click="confirm()">{{ft('globals.continue')}}</button>
              </div>
            </div>
            <!-- END TARGET SLIDE -->
            <!-- INDUSTRY SLIDE -->
            <div class="profiling-carousel-item industry px-2" key="slide-industry">
              <h3 class="text-center pb-4">{{content.industry.question}}</h3>
              <div class="text-center" v-html="content.industry.details" v-if="content.industry.details"></div>
              <div class="d-flex flex-column flex-lg-row justify-content-center flex-wrap">
                <div v-for="answer in industryAnswers" :key="`industry-${answer}`" class="industry-item py-2">
                  <div
                    class="cursor-pointer ar-1by1 tile w-100 h-100 d-flex flex-lg-column justify-content-lg-center align-items-center"
                    @click="toggleIndustryAnswer(answer)"
                    :class="{'active': industryAnswer == answer}"
                  >
                    <img :src="getContent(answer).icon.url" v-if="getContent(answer).icon" class="icon mb-3 mr-3 mr-lg-0"/>
                    <div class="d-flex align-items-center h-100">
                      <div class="small mt-lg-2" v-if="getContent(answer).title" v-html="getContent(answer).title"></div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="w-100 text-center mt-4">
                <button class="btn btn-primary my-3 my-md-0" :disabled="!canConfirm" :class="{'disabled': !canConfirm}" @click="confirm()">{{ft('globals.continue')}}</button>
              </div>
            </div>
            <!-- END INDUSTRY SLIDE -->
          </div>
        </div>
      </div>
    </div>
    <modal-warning
      v-if="warningMessage"
      :message="warningMessage"
      @cancel="warningMessage = null"
      @confirm="() => {
        industryAnswer = null;
        warningMessage = null;
        confirm();
      }"
    ></modal-warning>
  </div>
</template>

<style lang="scss">
[stripe-profiling-component] {
  min-height: calc(100vh - #{$header-height});

  .profiling-carousel-item {
    width: 100%;
  }

  .btn.disabled {
    cursor: not-allowed;
  }

  .arrow-container {
    width: 3rem;
    height: 3rem;

    .btn {
      padding: 0 !important;
      border-radius: 100%;
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;

      &:not(:hover) {
        background-color: $white;
      }
      
      .fa-2x {
        font-size: 1.5rem;
        margin-right: .25rem !important;
      }
    }
  }

  .topic {
    .topic-item {
      border-radius: 3rem;
      background-color: $white;
      transition: all .25s;

      &:hover {
        color: $gray-600;
      }

      &.active {
        background-color: $primary;
        color: $white;
      }
    }
  }

  .target-item {
    width: 25%;
  }

  .industry-item {
    width: 13rem;
  }

  .target-item, .industry-item {
    padding-left: 15px;
    padding-right: 15px;

    .tile {
      transition: color .25s, box-shadow .25s;
      border-radius: .5rem;
      padding: 2rem;
      color: black;
      line-height: 1;
      background-color: $white;

      .icon {
        height: 3rem;
        width: auto;
        transition: filter .25s;
      }
      
      .title {
        font-size: 1.25rem;
      }

      p {
        margin-bottom: 0;
        font-size: .875rem;
      }

      &.active {
        color: $primary;
        box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.32);

        .icon {
          @include recolor-icon;
        }
      }

      @include media-breakpoint-up(lg) {
        text-align: center;
      }
    }

    @include media-breakpoint-down(md) {
      width: 100%;
      padding: 0;

      .tile {
        padding: 15px;
      }
    }
  }
}
</style>
